import { createSelector } from 'reselect';

import { eventMetaDataSelector } from '../common/tracking/selectors';
import { TRACKING_SUB_AREA } from '../../trackingV2';
import { selectors } from '../filterBar';
import { FAILURE_ANALYSIS_TESTS_FILTER_MAP } from './constants';

export const failureAnalysisStore = (store) => store.apps.analytics.failureAnalysis;

export const failureAnalysisSelector = createSelector(
  failureAnalysisStore,
  eventMetaDataSelector,
  (failureAnalysis, eventMetaData) => ({
    loadingData: ['idle', 'loading'].includes(failureAnalysis.get('fetchStatus')),
    items: failureAnalysis.get('items'),
    getTestsError: failureAnalysis.get('getTestsError'),
    eventMetaData: {
      ...eventMetaData,
      product_sub_area: TRACKING_SUB_AREA.FAILURE_ANALYSIS,
    },
  }),
);

export const queryParamSelector = createSelector([
  selectors.selectRequestParams(FAILURE_ANALYSIS_TESTS_FILTER_MAP),
  (store, options) => options,
],
(filterParams, options = {}) => ({
  ...filterParams,
  ...options,
}));
